// QR code name only display

const qrCodeLabelOnly = (translate, qrCode) => {
  if (!qrCode) return '?';

  const {
    qrType,
    qrLbl,
  } = qrCode;

  if (qrType) {
    const type = translate(qrType, 'qrType');

    return type + (qrLbl || '');
  }

  return (qrLbl || '');
};

export default qrCodeLabelOnly;
